<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    computed: {
        ...mapGetters({
            roleCategories: 'roleCategories',
            roleGroups: 'roleGroups',
            roles: 'roles',
            user: 'user',
        }),

        selectedGroup() {
            if (this.user.role_group_id) {
                return this.roleGroups.find(
                    (x) => x.id == this.user.role_group_id
                )
            }
            return {}
        },
    },

    methods: {
        setRoleGroup(obj) {
            this.user.role_group_id = obj.id
            this.save()
        },
    },
}
</script>

<template lang="pug">
    acrm-panel.roles
        acrm-heading(:level="5" bold) {{ $t('ROLES.ROLE_SETTINGS') }}
        p {{ $t('ROLES.DESC') }}
        acrm-heading(:level="6" bold) {{ $t('ROLES.ROLE_GROUP') }}
        .row(v-if="!user.is_admin")
            .col.col-md-12
                acrm-multi-select.mb-4(
                    :value="selectedGroup"
                    @input="setRoleGroup($event)"
                    track-by="name"
                    option-label="name"
                    :options="roleGroups")
        .row(v-else)
            .col.col-md-24
                .text-center 
                    strong {{ $t('USERS.ISADMIN')}}
        template(v-if="user.role_group_id != null")
            acrm-role-form(v-for="(role, i) in roleCategories" :role="role" :key="role.key" :depth="0" :group="selectedGroup" :userId="user.id" :userRoles="user.roles ? user.roles : []")
</template>
